/* Spanish catalog mirroring locale-payroll-delivery-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'err.payslip.notAuthorized': 'No tienes acceso a esta solicitud de envío de recibos de nómina.',
  'err.payslip.approvedRunRequired': 'Aprueba la nómina antes de poner en cola los recibos de nómina de sus empleados.',
  'err.payslip.queueTooLarge': 'Los datos del recibo de nómina son demasiado grandes para ponerlos en cola. Contacta con soporte.',
  'pay.payslipSent': 'Recibo de nómina enviado.',
  'pay.payslipsSent': 'Recibos de nómina enviados.',
  'pay.payslipsSentAndPosted': 'Recibos de nómina enviados y nómina contabilizada.',
  'pay.payslipsQueuedAndPosted': 'Nómina contabilizada. Recibos de nómina en cola para su envío en segundo plano.',
  'pay.payslipQueued': 'En cola para envío',
  'pay.payslipsQueued': 'Recibos de nómina en cola para envío.',
  'pay.payslipGenerated': 'Generado',
  'pay.payslipNotReady': 'No listo',
  'pay.payslipScheduled': 'Programado',
});
